import http from '../assets/jslibs/axios/http';

//获取用户上次下单填写的信息
export const getOrderHistory = () => http.get('/v1/app/OrderHistory');

//服务下单
export const placeOrder = (data) => http.post('/v1/app/Order',data);

//获取订单列表
export const getOrderList = (data) => http.get('/v1/app/Order',data);

// 获取快捷标签
export const getQuickTag = (data) => http.get('/v1/app/QuickTag', data);

//订单详情
export const getOrderDetail = (data) => http.get(`/v1/app/Order/${data}`);

//删除订单
export const delOrders = (uuid) =>  http.delete(`/v1/app/Order/${uuid}`);

//确认支付
export const getOrderPay = (data) => http.post('/v1/app/OrderPay',data);

//取消/确认/驳回/催单/退款/撤销退款
export const operateOrder = (data,obj) => http.put(`/v1/app/Order/${data}`,obj);

//跟进订单
export const getOrderFollow = (data,obj) => http.get(`/v1/app/OrderFollowRecord/${data}`,obj);

//评价订单
export const getOrderComment= (data) => http.post('/v1/app/OrderComment',data);

//追加金额下单
export const getOrderAdd= (data) => http.post('/v1/app/OrderAdd',data);

//追加金额支付
export const getOrderAddPay= (data) => http.post('/v1/app/OrderAddPay',data);

//追加金额订单支付状态
export const getAddPayStatus= (data) => http.get(`/v1/app/OrderAdd/${data}`);

//获取业务员端订单列表
export const getSalesmanOrder= (data) => http.get('/v1/app/SalesmanOrder',data);

//获取业务员操作点订单
export const processingOrder= (data,obj) => http.put(`/v1/app/ProcessingOrder/${data}`,obj);

//业务员新增更近记录
export const orderFollowRecord= (data,obj) => http.put(`/v1/app/OrderFollowRecord/${data}`,obj);

//业务员获取进度标签
export const getProgressTag = (data) => http.get('/v1/app/ProgressTag', data);

//获取管理员端订单列表
export const getAdminOrder= (data) => http.get('/v1/app/AdminOrder',data);

// 管理远端操作订单
export const adminOrder= (data,obj) => http.put(`/v1/app/AdminOrder/${data}`,obj);

// 管理线下下单
export const placeOrderAdmin= (data) => http.post('/v1/app/AdminOrder',data);

//获取所有业务员列表
export const getSalesman= (data) => http.get('/v1/app/Salesman',data);

//获取默认佣金
export const getCommission= () => http.get('/v1/app/CommissionSetting');

//获取用户常用旺旺
export const getUserWangWang= () => http.get('/v1/app/UserWangWang');

//获取用户退款记录
export const getOrderRefundRecord= (data) => http.get('/v1/app/OrderRefundRecord',data);

//订单补充信息
export const addSupplement= (data) => http.post('/v1/app/Order/addSupplement',data);



